import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=28a8d990&"
import script from "./Statistics.vue?vue&type=script&lang=js&"
export * from "./Statistics.vue?vue&type=script&lang=js&"
import style0 from "./Statistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports